<template>
  <base-section id="theme-features">
    <base-section-heading title="Ganalla 80 Mesh">
      El granate CyD Group es un mineral natural totalmente ecológico, el cual es Garnet almandino, uno de los minerales más duros, éste es un granate de roca dura cristalina.
Nuestro Garnet CyD Group son granos angulares afilados que proporcionan una velocidad de corte superior, cortes más rectos (menos cónicos) y bordes más limpios.
Gracias a sus bordes afilados por triturado, este tipo de Garnet actúa más como una herramienta de corte afilado, por lo que es superior al aluvial y demuestra cortar mejor y más rápido.

    </base-section-heading>
  <v-container>
      <v-row>
        <v-col
          v-for="(feature, i) in features"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="feature"
            align="left"
            horizontal
          >
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Veritatis illum veniam cum dolores ratione commodi beatae quas maxime, laboriosam excepturi solut!
          </base-avatar-card>
        </v-col>
      </v-row>

      <iframe width="560" height="315" src="https://www.youtube.com/embed/Ml1UvOMsWyU" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </v-container>
  </base-section>
</template>
<script>
  export default {
    name: 'SectionThemeFeatures',

    data: () => ({
      features: [{
          color: 'blue',
          title: 'Seguro',
          icon: 'mdi-resize',
          text: 'Por ser atóxico, el Garnet CyD Group está muy por debajo de los valores máximos determinados por las normativas ambientales en relación a los componentes silicógenos (silicio cristalino), tóxicos y cancerígenos, garantizando un ambiente de trabajo seguro y limpio en el proceso de corte por agua.',
        },
        {
          color: 'blue',
          title: 'Uso',
          icon: 'mdi-gradient',
          text: 'Corte de todo tipo de materiales (piedra, metal, vidrio, cuero, plásticos, entre otros).',
        },
        {
          color: 'blue',
          title: 'Dureza y angulosidad',
          icon: 'mdi-diamond-stone',
          text: 'Las partículas angulares y una consistente uniformidad dan más control al operario de la boquilla para lograr el resultado final que busque en su trabajo.El Garnet CyD Group no sufre fraccionamiento en su procesado.Su alto grado de dureza, permite su reutilización hasta 7 veces sin grandes mermas de cualidades.No hay riesgo de silicosis. No es nocivo para la salud.',
        },
        {
          color: 'blue',
          title: 'Caracteristicas',
          icon: 'mdi-vector-rectangle',
          text: 'Mesh 80 escala granulométrica: 0,18-0,35 mm Color: de rosa a rojo oscuro Dureza: 7.5 – 8 Mohs',
        },
      ],
    }),
  }

</script>
